/** @format */
import angular from 'angular';
import angularTranslate from 'angular-translate';
import { PlanStudyRightService } from 'common-typescript';
import _ from 'lodash';
import { localeServiceModule } from 'sis-common';
import { attainmentTreeModule } from '../attainment/tree/attainmentTree.module';
import { localDateRangeFilterModule } from '../date/filters/localDateRange/localDateRange.filter';
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { IconComponent } from '../icon/icon.component';
import { commonModuleServiceModule } from '../service/module.service';
import { commonPlanSelectionServiceModule } from '../service/planSelection.service';
import { planValidationResultHelperModule } from '../service/planValidationResultHelper.service';
import { commonPlanModuleModule } from './planModule.comp';
import planStructureTpl from './planStructure.tpl.html';

export const planStructureModule = 'sis-components.plan.planStructure';

(function () {
    PlanStructureController.$inject = [
        '$q',
        '$translate',
        'localeService',
        'localDateRangeFilter',
        'commonEducationService',
        'defaultPromiseHandler',
        'commonStudentApplicationService',
        'commonStudyRightService',
        'planValidationResultHelper',
        'commonModuleService',
    ];
    angular
        .module(planStructureModule, [
            'sis-components.service.educationService',
            commonPlanModuleModule,
            errorServiceModule,
            attainmentTreeModule,
            'sis-components.service.studentApplicationService',
            'sis-components.service.studyRightService',
            IconComponent.downgrade.moduleName,
            angularTranslate,
            commonModuleServiceModule,
            localDateRangeFilterModule,
            localeServiceModule,
            planValidationResultHelperModule,
            commonPlanSelectionServiceModule,
        ])
        .component('planStructure', {
            template: planStructureTpl,
            controller: PlanStructureController,
            bindings: {
                plan: '<',
                validatablePlan: '<',
                planValidationResult: '<',
                moduleContentApprovalId: '<?',
            },
        });

    function PlanStructureController(
        $q,
        $translate,
        localeService,
        localDateRangeFilter,
        commonEducationService,
        defaultPromiseHandler, // NOSONAR
        commonStudentApplicationService,
        commonStudyRightService,
        planValidationResultHelper,
        commonModuleService,
    ) {
        const $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.ready = false;
            $ctrl.plan.cacheModulesAndCourseUnits();
            $ctrl.isOpen = true;
            $ctrl.titleAriaLabel = undefined;
        };

        $ctrl.$onChanges = changesObject => {
            if (changesObject.plan && changesObject.plan.currentValue) {
                $ctrl.ready = false;
                const newPlan = changesObject.plan.currentValue;
                const promises = [];

                const educationPromise = commonEducationService
                    .findById(newPlan.rootId)
                    .then(education => {
                        $ctrl.education = education;
                        return education;
                    })
                    .then(education => {
                        $ctrl.childModuleSelections = $ctrl.validatablePlan.getSelectedModulesById(education);
                        if (_.every($ctrl.childModuleSelections, { type: 'DegreeProgramme' })) {
                            $ctrl.childModuleSelections = commonModuleService.getDegreeProgrammesOrderedByTypeUrn(
                                $ctrl.childModuleSelections,
                            );
                        }
                        $ctrl.educationValidationResults = planValidationResultHelper.getModuleValidationResult(
                            _.get(education, 'id'),
                            $ctrl.planValidationResult,
                        );
                        setTitleAriaLabel();
                    })
                    .catch(defaultPromiseHandler.loggingRejectedPromiseHandler);

                promises.push(educationPromise);
                const moduleContentApprovalPromise = commonStudentApplicationService
                    .getApplicationsForStudentByTypes($ctrl.plan.userId, [
                        'CustomModuleContentApplication',
                        'RequiredModuleContentApplication',
                    ])
                    .then(applications => {
                        $ctrl.moduleContentApprovals = _.filter(
                            applications,
                            moduleContentApplication =>
                                _.includes(['REQUESTED', 'ACCEPTED', 'CONDITIONAL', 'IN_HANDLING'], moduleContentApplication.state) &&
                                moduleContentApplication.educationId === $ctrl.plan.rootId,
                        );
                        _.map(applications, moduleContentApplication => {
                            if (moduleContentApplication.id === $ctrl.moduleContentApprovalId) {
                                $ctrl.highlightedModuleId = moduleContentApplication.approvedModuleId;
                            }
                        });

                        return $ctrl.moduleContentApprovals;
                    })
                    .catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
                promises.push(moduleContentApprovalPromise);
                const studyRightPromise = commonStudyRightService
                    .findByPersonId($ctrl.plan.userId, false, false)
                    .then(studyRights => {
                        $ctrl.studyRights = studyRights;
                        return $ctrl.studyRights;
                    })
                    .catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
                promises.push(studyRightPromise);
                $q.all(promises).then(() => {
                    $ctrl.matchingStudyRight = _.find($ctrl.studyRights, studyRight => {
                        if (studyRight.educationId !== $ctrl.education.id) {
                            return false;
                        }
                        if (studyRight.learningOpportunityId !== newPlan.learningOpportunityId) {
                            return false;
                        }
                        if (studyRight.documentState !== 'ACTIVE') {
                            return false;
                        }
                        if (!_.includes(['ACTIVE', 'ACTIVE_NONATTENDING', 'PASSIVE', 'NOT_STARTED'], studyRight.state)) {
                            return false;
                        }
                        return true;
                    });
                    $ctrl.educationOptions = PlanStudyRightService.getValidatedEducationOptions(
                        $ctrl.validatablePlan,
                        $ctrl.education,
                        $ctrl.matchingStudyRight,
                    );
                    $ctrl.selectionPathInPlan = PlanStudyRightService.getSelectionPathInPlan($ctrl.validatablePlan, $ctrl.education, null);
                    $ctrl.ready = true;
                });
            }

            function setTitleAriaLabel() {
                const educationName = localeService.getLocalizedValue($ctrl.education.name);
                const validityPeriodHeading = $translate.instant('SIS_COMPONENTS.PLAN.EDUCATION_TOOLTIP.VALIDITY_PERIOD');
                const validityPeriod = localDateRangeFilter($ctrl.education.validityPeriod);
                $ctrl.titleAriaLabel = `${educationName}, ${validityPeriodHeading} ${validityPeriod}`;
            }
        };
    }
})();
